import {
	beginOptimisticUiMeta,
	commitOptimisticUiMeta,
	revertOptimisticUiWithFlagMeta,
	type OptimisticUiMeta,
	type OptimisticUiMetaWithFlag,
} from '../meta/optimistic-ui-meta.tsx';

export const BOARD_ISSUE_MOVE_CANCEL =
	'state.actions.board-issue-move.BOARD_ISSUE_MOVE_CANCEL' as const;

export type BoardIssueMoveCancelAction = {
	type: typeof BOARD_ISSUE_MOVE_CANCEL;
};

export const boardIssueMoveCancel = (): BoardIssueMoveCancelAction => ({
	type: BOARD_ISSUE_MOVE_CANCEL,
});

export const BOARD_ISSUE_MOVE_SHOW =
	'state.actions.board-issue-move.BOARD_ISSUE_MOVE_SHOW' as const;

export type BoardIssueMoveShowAction = {
	type: typeof BOARD_ISSUE_MOVE_SHOW;
};

export const boardIssueMoveShow = (): BoardIssueMoveShowAction => ({
	type: BOARD_ISSUE_MOVE_SHOW,
});

export const BOARD_ISSUE_MOVE_EXECUTE =
	'state.actions.board-issue-move.BOARD_ISSUE_MOVE_EXECUTE' as const;

export type BoardIssueMoveExecuteAction = {
	type: typeof BOARD_ISSUE_MOVE_EXECUTE;
	meta: OptimisticUiMeta;
};

export const boardIssueMoveExecute = (): BoardIssueMoveExecuteAction => ({
	type: BOARD_ISSUE_MOVE_EXECUTE,
	meta: beginOptimisticUiMeta(),
});

export const BOARD_ISSUE_MOVE_EXECUTE_SUCCESS =
	'state.actions.board-issue-move.BOARD_ISSUE_MOVE_EXECUTE_SUCCESS' as const;

export type BoardIssueMoveExecuteSuccessAction = {
	type: typeof BOARD_ISSUE_MOVE_EXECUTE_SUCCESS;
	meta: OptimisticUiMeta;
};

export const boardIssueMoveExecuteSuccess = (
	optimisticId: string,
): BoardIssueMoveExecuteSuccessAction => ({
	type: BOARD_ISSUE_MOVE_EXECUTE_SUCCESS,
	meta: commitOptimisticUiMeta(optimisticId),
});

export const BOARD_ISSUE_MOVE_EXECUTE_FAILURE =
	'state.actions.board-issue-move.BOARD_ISSUE_MOVE_EXECUTE_FAILURE' as const;

export type BoardIssueMoveExecuteFailureAction = {
	type: typeof BOARD_ISSUE_MOVE_EXECUTE_FAILURE;
	meta: OptimisticUiMetaWithFlag;
};

export const boardIssueMoveExecuteFailure = (
	optimisticId: string,
): BoardIssueMoveExecuteFailureAction => ({
	type: BOARD_ISSUE_MOVE_EXECUTE_FAILURE,
	meta: revertOptimisticUiWithFlagMeta(optimisticId),
});

export type BoardIssueMoveAction =
	| BoardIssueMoveCancelAction
	| BoardIssueMoveShowAction
	| BoardIssueMoveExecuteAction
	| BoardIssueMoveExecuteSuccessAction
	| BoardIssueMoveExecuteFailureAction;
